import axios from 'axios';
import i18n from 'i18next';

import { store } from 'store';
import { showAlert } from 'store/alert/alert.thunk';
import { authActions } from 'store/auth/auth.slice';
import authService from 'service/auth/authService';

const requestV2 = axios.create({
  baseURL: process.env.REACT_APP_URL_BASE_VERSION_2,
  timeout: 100000
});

const errorHandler = error => {
  const status = error?.response?.status;
  const refresh_token = store.getState().auth.token;
  const currentLanguage = i18n.language; // Get current language
  const error_code = error?.response?.data?.data?.error_code;

  if (
    status === 401 &&
    (!refresh_token || Object.keys(refresh_token).length === 0)
  ) {
    store.dispatch(authActions.logout());
    return Promise.reject(error);
  }

  if (status === 403 && (error_code === 10013 || error_code === 4013)) {
    store.dispatch(
      showAlert({
        title: `Forbidden: ${error.response?.data?.data?.info?.[currentLanguage]}`
      })
    );

    store.dispatch(authActions.logout());
    localStorage.clear();
  } else if (status === 401 && refresh_token) {
    const data = {
      token: refresh_token
    };

    const originalRequest = error.config;

    authService
      .refreshTokenFn(data)
      .then(res => {
        store.dispatch(authActions.setToken(res?.data?.access_token));
        window?.location?.reload();
        return requestV2(originalRequest);
      })
      .catch(error => {
        store.dispatch(authActions.logout());
        localStorage.clear();
        return Promise.reject(error);
      });
  } else if (status === 400) {
    store.dispatch(
      showAlert({
        title: `${error.response?.data?.data?.info?.[currentLanguage]}`
      })
    );
  } else if (status === 500) {
    store.dispatch(
      showAlert({
        title: `${error.response?.data?.data?.info?.[currentLanguage]}`,
        type: 'error'
      })
    );
  } else if (status === 409) {
    store.dispatch(
      showAlert({
        title: `${error.response?.data?.data?.info?.[currentLanguage]}`,
        type: 'error'
      })
    );
  } else if (status === 401) {
    console.log(
      'token expired ===>',
      error.response?.data?.data?.info?.[currentLanguage]
    );
  } else store.dispatch(showAlert({ title: '___ERROR___' }));

  return Promise.reject(error);
};

requestV2.interceptors.request.use(
  config => {
    const token = store.getState().auth.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },

  error => errorHandler(error)
);

requestV2.interceptors.response.use(
  response => response.data.data,
  errorHandler
);

export default requestV2;
